import { render } from "./TemplateAttributePicker.vue?vue&type=template&id=feb13a90&scoped=true"
import script from "./TemplateAttributePicker.vue?vue&type=script&lang=js"
export * from "./TemplateAttributePicker.vue?vue&type=script&lang=js"

import "./TemplateAttributePicker.vue?vue&type=style&index=0&id=feb13a90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feb13a90"]])

export default __exports__